import { createTheme, ThemeOptions } from "@mui/material";
import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { themeBase } from "./_themeBase";

const theme: ThemeOptions = {
  palette: {
    primary: {
      main: "#4543BC",
      dark: "#281C61",
      light: "#A9D2FF",
      base: "#E3F2F8",
      accent: "#6E69FF",
    },
    components: {
      slider: {
        rail: "#E3F2F8",
        track: "#281C61",
        thumbIcon: "#6E69FF",
        label: "#281C61",
      },
      progressBar: {
        rail: "#D9D9D9",
        track: "#4543BC",
      },
      buttonSelect: {
        backgroundColor: "#D8D8D8D8",
        textColor: "#333F48",
        backgroundColorActive: "#4543BC",
        textColorActive: "#FFFFFF",
        bordeColorActive: "#4543BC",
      },
    },
  },
};

export const CustomTheme = createTheme(themeBase, theme);

export const interfaceConfig: InterfaceConfig = {
  name: "kalapata",
  interest_rate: 30,
  maps: {
    api_key: import.meta.env.VITE_ENV === "PROD" ? "" : "",
  },
  companyNames: ["Lendit Group SAPI de CV"],
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_BeRV6uYmO",
      userPoolClientId: "208j2kkvh8r32d2a9qq926t33f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_Y0yNT5nH4",
      userPoolClientId: "78ctmcltm4h9r5g3lgie7fl65f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
};
